import type { TagsManager } from 'dxf-writer'
import DxfEllipse from 'dxf-writer/src/Ellipse.js'

/**
 * DXF 椭圆（ELLIPSE）实体，扩展 dxf-writer Ellipse 以支持线型、线宽与真彩色。
 */
export default class Ellipse extends DxfEllipse {
  /** 线型名称，默认跟随图层 */
  lineType: string = 'ByLayer'
  /** 线宽，单位百分之毫米；-1 表示跟随图层 */
  lineWidth: number = -1
  /** 真彩色 RGB 整数，undefined 表示不写入 */
  trueColor: number | undefined

  constructor(...args: any[]) {
    super(...args)
  }

  /**
   * 写入 ELLIPSE 组码序列。
   *
   * @param manager - DXF 标签写入器
   */
  tags(manager: TagsManager) {
    super.tags(manager)
    manager.push(6, this.lineType)
    manager.push(62, 256)
    manager.push(370, this.lineWidth)
    if (this.trueColor !== undefined) {
      manager.push(420, this.trueColor)
    }
  }
}
